module.exports = __webpack_public_path__ + "static/media/Salesforce-Screenshot.4a062098.svg";